import React from 'react'
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';

const NoticeFileList = ({
    columns,
    files,
    error,
    loading,
    columnVisibilityModel
}) => {
  return (
    <div style={{ display: 'flex', height: '200px' }}>
    <div style={{ flexGrow: 1 }}>
      <DataGrid
        rows={files ? files : []}
        columns={columns}
        columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
      />
    </div>
  </div>
  )
}

export default NoticeFileList